import * as React from 'react';

/**
 * SSR-safe `useLayoutEffect`. React 17 logs "useLayoutEffect does nothing on the server" whenever
 * a component using `useLayoutEffect` is rendered during SSR. The standard fix (used by
 * `react-redux`, `react-beautiful-dnd`, and the `apps/consumer` codebase) is to fall back to
 * `useEffect` on the server where layout measurement is meaningless anyway.
 *
 * Re-exported as `useLayoutEffect` so the `react-hooks` ESLint plugin still validates the
 * dependency array.
 */
const useIsomorphicLayoutEffect: typeof React.useLayoutEffect =
	typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;

export { useIsomorphicLayoutEffect as useLayoutEffect };
